import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchInput", "topicCard", "emptyState", "resultsCount"]

  connect() {
    this.updateResultsCount()
  }

  filter() {
    const query = this.searchInputTarget.value.toLowerCase().trim()
    let visibleCount = 0

    this.topicCardTargets.forEach(card => {
      const topicName = card.dataset.topicName.toLowerCase()
      const matches = topicName.includes(query)
      
      if (matches) {
        card.classList.remove("hidden")
        visibleCount++
      } else {
        card.classList.add("hidden")
      }
    })

    this.updateResultsCount()
    this.toggleEmptyState(visibleCount === 0)
  }

  clear() {
    this.searchInputTarget.value = ""
    this.filter()
  }

  updateResultsCount() {
    if (this.hasResultsCountTarget) {
      const visibleCount = this.topicCardTargets.filter(card => 
        !card.classList.contains("hidden")
      ).length
      const totalCount = this.topicCardTargets.length
      this.resultsCountTarget.textContent = `${visibleCount} of ${totalCount} topics`
    }
  }

  toggleEmptyState(show) {
    if (this.hasEmptyStateTarget) {
      if (show) {
        this.emptyStateTarget.classList.remove("hidden")
      } else {
        this.emptyStateTarget.classList.add("hidden")
      }
    }
  }
}
